import { ui } from '../styles/ui'

export const MODES = ['correct_code_only', 'convert_amount', 'disabled']
export const STATUSES = ['active', 'inactive', 'draft']

export const EMPTY_FORM = {
  code: '',
  fromCurrency: '',
  toCurrency: '',
  countryCode: '',
  countryName: '',
  effectiveFrom: '',
  legalTenderUntil: '',
  dualDisplayUntil: '',
  fixedConversionRate: '',
  mode: 'correct_code_only',
  status: 'active',
  priority: '100',
  sourceUrl: '',
  notes: '',
}

function toInputDate(value) {
  if (!value) return ''
  const text = String(value)
  return text.length >= 10 ? text.slice(0, 10) : text
}

function toIsoDate(value) {
  if (!value) return null
  return `${value}T00:00:00.000Z`
}

export function mapRuleToForm(rule) {
  return {
    code: rule.code || '',
    fromCurrency: rule.fromCurrency || '',
    toCurrency: rule.toCurrency || '',
    countryCode: rule.countryCode || '',
    countryName: rule.countryName || '',
    effectiveFrom: toInputDate(rule.effectiveFrom),
    legalTenderUntil: toInputDate(rule.legalTenderUntil),
    dualDisplayUntil: toInputDate(rule.dualDisplayUntil),
    fixedConversionRate: rule.fixedConversionRate == null ? '' : String(rule.fixedConversionRate),
    mode: rule.mode || 'correct_code_only',
    status: rule.status || 'active',
    priority: String(rule.priority ?? 100),
    sourceUrl: rule.sourceUrl || '',
    notes: rule.notes || '',
  }
}

export function validateForm(form) {
  const errors = {}

  if (!form.code.trim()) errors.code = 'Code is required.'
  if (!/^[A-Z]{3}$/.test(form.fromCurrency.trim())) {
    errors.fromCurrency = 'From currency must be exactly 3 uppercase letters.'
  }
  if (!/^[A-Z]{3}$/.test(form.toCurrency.trim())) {
    errors.toCurrency = 'To currency must be exactly 3 uppercase letters.'
  }
  if (form.countryCode.trim() && !/^[A-Z]{2}$/.test(form.countryCode.trim())) {
    errors.countryCode = 'Country code must be exactly 2 uppercase letters.'
  }
  if (!form.effectiveFrom.trim()) {
    errors.effectiveFrom = 'Effective from date is required.'
  }
  if (form.fixedConversionRate !== '') {
    const rate = Number(form.fixedConversionRate)
    if (!Number.isFinite(rate) || rate <= 0) {
      errors.fixedConversionRate = 'Fixed conversion rate must be a positive number.'
    }
  }
  const priority = Number(form.priority)
  if (!Number.isInteger(priority)) {
    errors.priority = 'Priority must be an integer.'
  }
  if (form.sourceUrl.trim()) {
    try {
      // eslint-disable-next-line no-new
      new URL(form.sourceUrl.trim())
    } catch (_error) {
      errors.sourceUrl = 'Source URL must be a valid URL.'
    }
  }
  if (!MODES.includes(form.mode)) {
    errors.mode = 'Mode is invalid.'
  }
  if (!STATUSES.includes(form.status)) {
    errors.status = 'Status is invalid.'
  }

  return errors
}

export function buildPayload(form) {
  return {
    code: form.code.trim(),
    fromCurrency: form.fromCurrency.trim(),
    toCurrency: form.toCurrency.trim(),
    countryCode: form.countryCode.trim() || null,
    countryName: form.countryName.trim() || null,
    effectiveFrom: toIsoDate(form.effectiveFrom),
    legalTenderUntil: toIsoDate(form.legalTenderUntil),
    dualDisplayUntil: toIsoDate(form.dualDisplayUntil),
    fixedConversionRate: form.fixedConversionRate === '' ? null : Number(form.fixedConversionRate),
    mode: form.mode,
    status: form.status,
    priority: Number(form.priority),
    sourceUrl: form.sourceUrl.trim() || null,
    notes: form.notes.trim() || null,
  }
}

export function badgeClass(type) {
  if (type === 'active' || type === 'correct_code_only') return `${ui.badges.base} ${ui.badges.success}`
  if (type === 'draft' || type === 'convert_amount') return `${ui.badges.base} ${ui.badges.warning}`
  if (type === 'inactive' || type === 'disabled') return `${ui.badges.base} ${ui.badges.danger}`
  return `${ui.badges.base} ${ui.badges.neutral}`
}
